module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/drs.md absPath of file >>> MarkdownRemark","html":"<p>Delaware River Solar</p>","fields":{"slug":"/drs/"},"frontmatter":{"date":"April 10, 2018","title":"DRS","cover":"/img/common.png","meta_title":"Drs","meta_description":"Drs","username":"Drs","tags":["Drs"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/drs.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/drs.json
// module id = 426
// module chunks = 159252340728242